import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76fa18ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo_wrap_bg" }, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "submenu_icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_link = _resolveComponent("app-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_WebHeader = _resolveComponent("WebHeader")!
  const _component_HelperHeader = _resolveComponent("HelperHeader")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_c_Modal = _resolveComponent("c-Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { class: "layout_wrap" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_a_layout_sider, {
          collapsed: _ctx.collapsed,
          "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collapsed) = $event)),
          "collapsed-width": 64,
          trigger: null,
          width: 190,
          breakpoint: "lg",
          class: "layout_menu_wrap",
          theme: _ctx.homeStore.theme,
          collapsible: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_link, {
              to: _ctx.helper ? '/' : _ctx.customData.top_logo_link,
              class: "logo_wrap"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", {
                  class: _normalizeClass(["logo", _ctx.logoClassName])
                }, [
                  _withDirectives(_createElementVNode("img", {
                    class: "logo_fullname",
                    src: _ctx.logoUrl
                  }, null, 8, _hoisted_3), [
                    [_vShow, _ctx.logoUrl]
                  ])
                ], 2)
              ]),
              _: 1
            }, 8, ["to"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
              return (_openBlock(), _createBlock(_component_a_menu, {
                key: item.name,
                selectedKeys: _ctx.selectedKeys,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                "open-keys": _ctx.openKeys,
                "inline-indent": 18,
                class: "layout_menu",
                theme: _ctx.homeStore.theme,
                mode: "inline",
                onOpenChange: _ctx.onOpenChange
              }, {
                default: _withCtx(() => [
                  (item?.children && !item.meta?.hideMenu)
                    ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                        key: item.name
                      }, {
                        expandIcon: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_svg_icon, {
                              class: _normalizeClass(["submenu_icon_down", { submenu_icon_open: _ctx.openKeys[0] === item.name }]),
                              "icon-class": "submenu_down"
                            }, null, 8, ["class"])
                          ])
                        ]),
                        icon: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            class: "homemenu_icon",
                            "icon-class": item.meta?.icon
                          }, null, 8, ["icon-class"])
                        ]),
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.meta?.title), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: child.path
                            }, [
                              (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: child.name,
                                class: "layout_menu_item"
                              }, {
                                icon: _withCtx(() => [
                                  (child.meta?.icon)
                                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                                        key: 0,
                                        "icon-class": child.meta?.icon,
                                        class: "child_icon"
                                      }, null, 8, ["icon-class"]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_app_link, {
                                    to: child.path,
                                    applink: child.meta?.applink === false ? false : true,
                                    target: "_block"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(child.meta?.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "applink"])
                                ]),
                                _: 2
                              }, 1024))
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: item?.name
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            class: "homemenu_icon",
                            "icon-class": item.meta?.icon
                          }, null, 8, ["icon-class"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_app_link, {
                            to: item.path,
                            applink: item.meta?.applink === false ? false : true,
                            target: "_block"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.meta?.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "applink"])
                        ]),
                        _: 2
                      }, 1024))
                ]),
                _: 2
              }, 1032, ["selectedKeys", "open-keys", "theme", "onOpenChange"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["collapsed", "theme"]), [
          [_vShow, !_ctx.customLayoutStyle && _ctx.homeStore.menuVisible && !_ctx.isExamine && !_ctx.homeStore.isFullScreen]
        ]),
        _createVNode(_component_a_layout, { class: "layout_content_wrap" }, {
          default: _withCtx(() => [
            (_ctx.homeStore.menuVisible && !_ctx.isExamine && !_ctx.homeStore.isFullScreen)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.helper)
                    ? (_openBlock(), _createBlock(_component_WebHeader, {
                        key: 0,
                        isCollapsed: _ctx.collapsed,
                        "source-data": _ctx.userMenu,
                        onSwitch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setShowCollapsed()))
                      }, null, 8, ["isCollapsed", "source-data"]))
                    : (_openBlock(), _createBlock(_component_HelperHeader, {
                        key: 1,
                        isCollapsed: _ctx.collapsed,
                        onSwitch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShowCollapsed()))
                      }, null, 8, ["isCollapsed"]))
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_a_layout_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_config_provider, { locale: _ctx.locale }, {
                  renderEmpty: _withCtx(() => [
                    _createVNode(_component_a_empty, {
                      class: "empty_wrap",
                      image: _ctx.emptyDataSec,
                      description: "页面暂无数据信息~"
                    }, null, 8, ["image"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_config_provider, { locale: _ctx.elLocale }, {
                      default: _withCtx(() => [
                        (_ctx.isRouterAlive && _ctx.autoStaus)
                          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["locale"])
                  ]),
                  _: 1
                }, 8, ["locale"])
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_ctx.customData.copyright), 513), [
              [_vShow, !_ctx.customFootStyle && _ctx.route.meta.menuType !== 'gateway']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_c_Modal, {
      visible: _ctx.isVisible,
      close: _ctx.isopenDelModal,
      centered: ""
    }, null, 8, ["visible", "close"])
  ]))
}